import { InputBase, InputHolidayMultipliersController } from "../../controllers";
import { ComponentBase } from "../_ComponentBase";

/**
 * Form control for defining multipliers for holiday pay calculations.
 * @example
 * ```html
 * <salaxy-input-holiday-multipliers name="multipliers" ng-model="settings.multipliers" label="Multipliers for holiday pay calculation"></salaxy-input-holiday-multipliers>
 * ```
 */
export class InputHolidayMultipliers extends ComponentBase {

    /** ng-model is required, form tag is optionally used for validation and disabled/readonly */
    public require = {
      model: "ngModel",

      form: "?^^form",
  };

    /**
     * The following component properties (attributes in HTML) are bound to the Controller.
     * For detailed functionality, refer to [controller](#controller) implementation.
     */
    public bindings = InputBase.crudBindings;

    /** Uses the InputHolidayMultipliersController */
    public controller = InputHolidayMultipliersController;

    /** The default template for the component. */
    public defaultTemplate = "salaxy-components/form-controls/InputHolidayMultipliers.html";
}
